<template>
    <div v-if="!showAllPoints && leftPoints > 0" @click="toggleShowAllPoints" class="mx-auto w-fit cursor-pointer">
        <span class="block text-xs text-center mb-4">
            {{ $t('Bbk.storeLocatorPoint.loadMore') }} ({{ leftPoints }})
        </span>
        <div class="mx-auto w-9 h-9 bg-black rounded-full flex justify-center items-center">
            <ShcUiIcon name="arrow_downward" class="relative left-[-1px] text-2xl leading-none text-white font-bold" />
        </div>
    </div>

    <div v-if="showAllPoints && leftPoints > 0" @click="toggleShowAllPoints" class="mx-auto w-fit cursor-pointer">
        <span class="block text-xs text-center mb-4">
            {{ $t('Bbk.storeLocatorPoint.hidePoints') }} ({{ leftPoints }})
        </span>
        <div class="mx-auto w-9 h-9 bg-black rounded-full flex justify-center items-center">
            <ShcUiIcon name="arrow_upward" class="relative left-[-1px] text-2xl leading-none text-white font-bold" />
        </div>
    </div>
</template>

<script setup lang="ts">
    import type { Props } from './props'

    const props = defineProps<Props>()
    const { $bus } = useNuxtApp()

    function toggleShowAllPoints() {
        $bus.$emit('toggleStoreLocatorAllPoints')
    }
</script>
